export class LazyCarousel {

    constructor() {
        $(function() {
            $(".lazy-carousel").on("slide.bs.carousel", function(e) {
                window.LazyCarousel.loadImage($(e.relatedTarget).find("img[data-src]"));
            });
        });
    }

    loadImage(image) {
        image.attr("src", image.data('src'));
        image.removeAttr("data-src");
    }


}




